import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import './Home.css'
import Navbar from '../../components/Navbar/Navbar'
import Sidebar from '../../components/Sidebar/Sidebar'
import API from '../../utils/API'

function Home(props) {
  // Get window location to pass to sidebar
  const location = useLocation();
  const navigate = useNavigate();

  const { user, isSidebarOpen, setIsSidebarOpen } = props;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(()=>{
    API.updateUserLastSeen()
    .catch((err)=>{
      console.error(`Error updating user's last seen date`);
      console.error(err);
    })
    let interval = setInterval(()=>{
      API.updateUserLastSeen()
      .then((res) => {
        // pass
      })
      .catch((err)=>{
        console.error(`Error updating user's last seen date`);
        console.error(err);
      })
    }, 1000*60)
    return () => clearInterval(interval);
  }, [])

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen])

  useEffect(() => {
    console.log('(Home.js) User:', user)
  }, [user])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const sidebarProps = {
    isSidebarOpen, 
    setIsSidebarOpen,
    isMobileMenuOpen,
    closeMobileMenu
  }

  const navbarProps = {
    toggleMobileMenu
  }

  return (
    <>
      <Navbar {...navbarProps} />
      <Sidebar {...sidebarProps} />
      <div className='wrapper'>
        <Outlet isSidebarOpen={isSidebarOpen} />
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Home)
